/**
  * 能源管理主页--深色折线图 
  * @param title
  * @param unit 单位
  * @param xData []x轴数据
  * @param dataArr [{name:'',data:[]}]y轴数据合集
*/
export function setOption(paramObj) {
  let colorArr = [
    { color1: "rgba(220,181,2,1)", color2: "rgba(45,48,46,.1)" },
    { color1: "rgb(0,227,255)", color2: "rgba(9,46,73,.3)" },
  ];
  let option = {
    title: {
      show: paramObj.title ? true : false,
      text: paramObj.title,
      textStyle: {
        fontSize: 12,
        color: "#fff",
      },
      top: "2%",
    },
    grid: {
      top: "50px",
      left: "60px",
      right: "15px",
      bottom: "40px",
    },
    legend: {
      show: true,
      textStyle: {
        color: "#fff",
      },
      right: "2%",
      top: "2%",
    },
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            item.value +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    xAxis: [
      {
        type: "category",
        data: paramObj.xData,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          interval: 0,
          color: "rgb(1,171,213)",
          margin: 15,
        },
        boundaryGap: false,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "单位:" + paramObj.unit,
        nameTextStyle: {
          color: "#82AFC6",
          fontSize: 10,
          padding: [0, 0, 0, -30],
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },

        axisLabel: {
          color: "rgb(116,166,181)",
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#0F2766",
          },
        },
      },
    ],
    series: [],
  };
  paramObj.dataArr.map((v, i) => {
    option.series.push({
      name: v.name,
      type: "line",
      data: v.data,
      symbolSize: 6,
      symbol: "circle",
      lineStyle: {
        color: colorArr[i].color1,
      },
      itemStyle: {
        color: colorArr[i].color1,
        borderColor: colorArr[i].color1,
      },
      areaStyle: {
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: colorArr[i].color1,
            },
            {
              offset: 1,
              color: colorArr[i].color2,
            },
          ],
          globalCoord: false,
        },
      },
    });
  });

  return option
  
}